const initialState = {
    general: {

    },
    users: {
        users: null,
        filter: null,
    },
    user: null,
    payments: {
        payments: null,
        filter: null
    },
    withdrawals: {
        withdrawals: [],
        filter:null
    },
    discountCodes: {
        discountCodes: [],
        filter:null
    },
    status: {
        joinChallengeEnabled: null,
        challengeStartEnabled: null,
        disturbanceMessage: null,
    },
    runningChallenges: [],
    finishedChallenges: [],
    availableChallenges: [],
    challenge: null,
    logs: [],
    isError: false,
    errorMessages: []
};

export function adminReducer(state = initialState, action) {
    switch (action.type) {
        case "RUNNING_CHALLENGES":
            return {
                ...state,
                runningChallenges: action.runningChallenges,
            }
        case "FINISHED_CHALLENGES":
            return {
                ...state,
                finishedChallenges: action.finishedChallenges,
            }
        case "AVAILABLE_CHALLENGES":
            return {
                ...state,
                availableChallenges: action.availableChallenges,
            }
        case "CHALLENGE":
            return {
                ...state,
                challenge: action.challenge,
            }
        case "GENERAL":
            return {
                ...state,
                general: action.general,
            }
        case "USERS":
            return {
                ...state,
                users: {
                    ...state.users,
                    users: action.users,
                }
            }
        case "USER":
            return {
                ...state,
                user: action.user,
            }
        case "UPDATE_USER":
            return {
                ...state,
                user: {
                    ...state.user,
                    ...action.user
                },
            }
        case "FILTER_USERS":
            return {
                ...state,
                users: {
                    ...state.users,
                    filter: action.filter,
                }
            }
        case "PROMOTION":
            return {
                ...state,
                user: {
                    ...state.user,
                    amount: action.promotion.newAmount,
                    transactions : [action.promotion.transaction, ...state.user.transactions]
                },
            }
        case "PAYMENTS":
            return {
                ...state,
                payments: {
                    ...state.payments,
                    payments: action.payments,
                }
            }
        case "WITHDRAWALS":
            return {
                ...state,
                withdrawals: {
                    ...state.withdrawals,
                    withdrawals: action.withdrawals,
                }
            }
        case "UPDATED_WITHDRAWAL":
            return {
                ...state,
                withdrawals: {
                    ...state.withdrawals,
                    withdrawals: state.withdrawals.withdrawals.map((item, index) => {
                        if (item.id === action.withdrawal.id) {
                            return action.withdrawal;

                            
                        }
                        return item;
                    })
                }
            }
        case "DISCOUNT_CODE":
            return {
                ...state,
                discountCodes: {
                    ...state.discountCodes,
                    discountCodes: [action.discountCode, ...state.discountCodes.discountCodes]
                },
            }
        case "UPDATED_DISCOUNT_CODE":
            return {
                ...state,
                discountCodes: {
                    ...state.discountCodes,
                    discountCodes: state.discountCodes.discountCodes.map((item, index) => {
                        if (item.id === action.updatedDiscountCode.id) {
                            return action.updatedDiscountCode;


                        }
                        return item;
                    })
                },
            }
        case "DELETED_DISCOUNT_CODE":
            return {
                ...state,
                discountCodes: {
                    ...state.discountCodes,
                    discountCodes: state.discountCodes.discountCodes.filter(item => item.id !== action.deletedDiscountCode.id)
                },
            }
        case "DISCOUNT_CODES":
            return {
                ...state,
                discountCodes: {
                    ...state.discountCodes,
                    discountCodes: action.discountCodes,
                }
            }
        case "SERVICE_TEXT":
            return {
                ...state,
                status: {
                    ...state.status,
                    disturbanceText: action.text,

                }
            }
        case "SERVICE_STATUS":
            return {
                ...state,
                status: {
                    joinChallengeEnabled: action.serviceStatus.allowJoinChallenge,
                    challengeStartEnabled: action.serviceStatus.allowChallengeToStart,
                    disturbanceText: action.serviceStatus.disturbanceMessage,
                    botsEnabled: action.serviceStatus.botsEnabled,
                }
            }
        case "LOGS":
            return {
                ...state,
                logs: action.logs.results,
            }
        case "CANCEL_CHALLENGE_JOB":
            const id = action.id;
            return {
                ...state,
                runningChallenges: state.runningChallenges.map((item, index) => {
                    if (item.id === id) {
                        return {
                            ...item,
                            interrupt: true,
                           
                        };
                    }
                    return item;
                })
            }
        case "IS_WORKING":
            return {
                ...state,
                working: true,

            }
        case "FINISHED_WORKING":
            return {
                ...state,
                working: false,

            }
        case "SET_ERROR":
            return {
                ...state,
                isError: true,
                errorMessages: [...state.errorMessages, action.errorMessage]

            }
        case "CLEAR_ERROR":
            return {
                ...state,
                isError: false,
                errorMessages: []

            }
        default:
            return state;
    }
}